<template>
	<div class="content-class">
		<v-tabs v-model="active" color="black" dark slider-color="primary">
			<v-tab :key="'bot'" ripple>Bot</v-tab>
			<v-tab :key="'License'" ripple v-if="document && document.licensed">Licences</v-tab>
			<v-tab :key="'Logs'" ripple>Logs</v-tab>

			<v-tab-item :key="'bot'">
				<bot-form v-model="document"> </bot-form>
				<v-btn color="primary" @click="importData">Importer les données botNation</v-btn>
				<v-btn color="primary" @click="duplicateBot">Dupliquer</v-btn>
			</v-tab-item>

			<v-tab-item :key="'License'" v-if="document && document.licensed">
				<v-container>
					<v-label>Licences disponibles : {{ availableLicenses }} </v-label>
					<br />
					<v-label>Licences utilisées : {{ usedLicenses }} </v-label>
					<br />
					<v-btn :disabled="loading" color="primary" @click="importLicenses">Importer des licenses</v-btn>
				</v-container>
			</v-tab-item>

			<v-tab-item :key="'Logs'">
				<log-list :url="'logs?filter=references.reference:$eq:bots;references.referenceId:$eq:' + $route.params.botId">
				</log-list>
			</v-tab-item>
		</v-tabs>
	</div>
</template>
<script>
import BotForm from '../../components/bots/bot.form'
import LogList from '../../components/logs/log.list.vue'

import { ERROR, SUCCESS } from '../../variables'

export default {
	components: { BotForm, LogList },
	data() {
		return {
			availableLicenses: null,
			usedLicenses: null,
			loading: false,
			active: null,
			document: null,
		}
	},
	methods: {
		importLicenses(file) {
			let input = document.createElement('input')

			input.onchange = (event) => {
				this.loading = true
				let formData = new FormData()
				formData.append('file', event.target.files[0])

				this.axios
					.post('bots/' + this.$route.params.botId + '/licenses', formData, {
						headers: {
							'content-type': 'multipart/form-data',
						},
					})
					.then((response) => {
						this.$store.dispatch(SUCCESS, 'Licences importées')
						this.getLicenseCount()
						this.loading = false
					})
					.catch((err) => {
						console.log(err)
						this.$store.dispatch(ERROR, "Erreur lors de l'import des licences")
						this.loading = false
					})
			}

			input.type = 'file'
			input.accept = '.csv'
			input.click()
		},
		duplicateBot() {
			this.$router.push({ name: 'AddBot', query: { duplicate: this.$route.params.botId } })
		},
		importData() {
			let input = document.createElement('input')

			input.onchange = (event) => {
				let formData = new FormData()
				formData.append('file', event.target.files[0])

				this.axios
					.post('bots/' + this.$route.params.botId + '/botnationImport', formData, {
						headers: {
							'content-type': 'multipart/form-data',
						},
					})
					.then((response) => {
						this.$store.dispatch(SUCCESS, 'Données importées')
					})
					.catch((err) => {
						console.log(err)
					})
			}

			input.type = 'file'
			input.click()
		},
		getLicenseCount() {
			this.axios
				.get('licenses/' + this.$route.params.botId)
				.then((response) => {
					this.availableLicenses = response.data.available
					this.usedLicenses = response.data.used
				})
				.catch((err) => {
					this.$store.dispatch(ERROR, err)
				})
		},
		init() {
			this.axios
				.get('bots/' + this.$route.params.botId)
				.then((response) => {
					this.document = response.data
					if (this.document.licensed) {
						this.getLicenseCount()
					}
				})
				.catch((err) => {
					this.$store.dispatch(ERROR, err)
				})
		},
	},
	watch: {
		'$route.params.botId': function() {
			this.init()
		},
	},
	mounted() {
		this.init()
	},
}
</script>
<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/bots/bot.detail.vue